import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';

import trScreenVideo from '../../../../../assets/video/tr-screen-video.mp4';
import trVideoMobile from '../../../../../assets/video/tr-video-mobile.mp4';
import Prompt from '../../../../Prompt/Prompt';

import {
  TXTCLI_Explore_PokerStars,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Make_your_first_deposit_and_cl_ELL,
  TXTWCL_YouXre_good_to_go
} from './RMFEKYCSuccessPrompt.messages.json';

const RMFEKYCSuccessPrompt: React.FC = () => {
  const form = useForm();
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;
  const exitWizard = useWizardExit();
  const props = {
    title: { translation: TXTWCL_YouXre_good_to_go },
    primaryButton: { translation: TXTWCL_Continue_to_deposit },
    onPrimaryButtonClick: () => form.submit(),
    secondaryButton: { translation: TXTCLI_Explore_PokerStars },
    onSecondaryButtonClick: exitWizard
  };
  const content = <Translation {...TXTWCL_Make_your_first_deposit_and_cl_ELL} />;

  return (
    <Prompt noCloseButton variant="info" video={video} {...props}>
      <Typography>{content}</Typography>
    </Prompt>
  );
};

export default RMFEKYCSuccessPrompt;
